import { RecommendationsBasedOnInterest, usePrioritizeInterestRecommendations } from '../features/recommendations';
import HomePageSection from '../components/Layouts/HomePageSection';
import { RankedRecommendations } from '../features/recommendations/components/RankedRecommendations';
import { jsx as _jsx } from "react/jsx-runtime";
const RecommendationsContainer = ({
  cardSize,
  onRenderEmpty
}) => {
  const {
    prioritizeInterestRecommendations,
    isLoading: prioritizeInterestRecommendationsLoading,
    hasError: prioritizeInterestRecommendationsError
  } = usePrioritizeInterestRecommendations();
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx("div", {
      "data-loading": prioritizeInterestRecommendationsLoading,
      "data-test-id": "recommendation-cards-container",
      children: !prioritizeInterestRecommendations ? /*#__PURE__*/_jsx(RankedRecommendations, {
        cardSize: cardSize,
        containerError: prioritizeInterestRecommendationsError,
        containerLoading: prioritizeInterestRecommendationsLoading,
        onRenderEmpty: onRenderEmpty
      }) : /*#__PURE__*/_jsx(RecommendationsBasedOnInterest, {
        containerError: prioritizeInterestRecommendationsError,
        containerLoading: prioritizeInterestRecommendationsLoading,
        onRenderEmpty: onRenderEmpty
      })
    })
  });
};
export default RecommendationsContainer;